// extracted by mini-css-extract-plugin
export default {"page":"UserAgreementPage_page__+OOPp","container":"UserAgreementPage_container__RQvNo"};